var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,20.35c-4.55,0-8.25-3.74-8.25-8.35S7.45,3.65,12,3.65s8.25,3.74,8.25,8.35-3.7,8.35-8.25,8.35Zm0-15.19c-3.72,0-6.75,3.07-6.75,6.85s3.03,6.85,6.75,6.85,6.75-3.07,6.75-6.85-3.03-6.85-6.75-6.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,6.59c-2.94,0-5.34,2.41-5.34,5.41s2.4,5.41,5.34,5.41,5.34-2.41,5.34-5.41-2.4-5.41-5.34-5.41Zm-.21,9.19c-.45,0-.81-.36-.81-.79s.36-.8,.81-.8,.81,.36,.81,.8-.37,.79-.81,.79Zm1.38-3.38c-.49,.35-.87,.65-.87,1.16v.22h-1.11v-.22c0-.91,.56-1.38,1.09-1.79,.45-.36,.86-.7,.86-1.28,0-.68-.42-1.13-1.12-1.13s-1.2,.53-1.2,1.3h-1.27c0-1.43,1.05-2.44,2.5-2.44s2.39,.86,2.39,2.19c0,1.07-.69,1.58-1.27,1.99Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/Question-Icon.7695ed087d65b69c0d37493df2e86a39.svg";
export { ForwardRef as ReactComponent };